<template>
  <div class="cadfm-container-horizontal">
            <Left v-show="isVisibleLeft" :lang="lang.Left"></Left>
            <Middle :routingData="routingData" :lang="lang.Middle"></Middle>
            <Right v-show="isVisibleRight" :lang="lang.Right" class="LibraryDetailsRight"></Right>

 </div>
</template>

<script>
import Left from '@/components/LibraryManager/Views/LibraryDetails/Left/Left'
import Middle from '@/components/LibraryManager/Views/LibraryDetails/Middle/Middle'
import Right from '@/components/LibraryManager/Views/LibraryDetails/Right/Right'
//import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'


export default {
  name: 'LibraryDetails',
  components:{
    Left,
    Middle,
    Right
  },
  data () {
    return {
      isVisibleRight: true,
      isVisibleLeft: true
    }
  },
  props:{
    routingData: Object,
    lang: Object
  },
}
</script>


<style scoped>
  .LibraryDetailsRight{
    max-width: 600px;
  }
</style>



// WEBPACK FOOTER //
// src/components/LibraryManager/Views/LibraryDetails.vue